import axios from "axios";

export const axiosClient = axios.create({
    baseURL: BASE_WEBSITE_URL+"/api/",
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector(('meta[name="csrf-token"]')).getAttribute('content')
    }
})
